import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WLatestNewsCCD: IClientComponentDefinition = {
  name: 'WLatestNews',
  load: () => import(/* webpackChunkName: 'WLatestNews' */ './w-latest-news.component'),
}
